import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=32e37907&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e37907')) {
      api.createRecord('32e37907', component.options)
    } else {
      api.reload('32e37907', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=32e37907&", function () {
      api.rerender('32e37907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/layouts/Header.vue"
export default component.exports